import React from 'react';
import { TeamCalendarEvent } from 'data/schemas/TeamCalendar';
import { formatDateLabel, formatTimeLabel } from './dateUtils';

interface Props {
    title: string;
    events: TeamCalendarEvent[];
    onSelectEvent?: (event: TeamCalendarEvent) => void;
    emptyMessage: string;
}

function EventListPanel(props: Props) {
    const { title, events, onSelectEvent, emptyMessage } = props;

    return (
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="border-b border-gray-200 px-4 py-3">
                <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">{title}</h3>
            </div>
            <div className="max-h-[28rem] space-y-3 overflow-y-auto p-4">
                {events.length === 0 && <p className="text-sm text-gray-500">{emptyMessage}</p>}
                {events.map(event => (
                    <button
                        key={event.id}
                        type="button"
                        onClick={() => onSelectEvent?.(event)}
                        className="w-full rounded-lg border border-gray-200 p-3 text-left transition hover:border-blue-300 hover:bg-blue-50"
                    >
                        <div className="mb-2 flex items-center justify-between gap-3">
                            <span
                                className="inline-flex rounded-full px-2 py-1 text-[11px] font-semibold uppercase tracking-wide text-white"
                                style={{ backgroundColor: event.color || '#2563eb' }}
                            >
                                {event.status}
                            </span>
                            <span className="text-xs text-gray-500">{event.teamName || 'No team'}</span>
                        </div>
                        <div className="font-semibold text-gray-800">{event.title}</div>
                        <div className="mt-1 text-sm text-gray-500">
                            {formatDateLabel(new Date(event.startAt))}
                            {' · '}
                            {event.isAllDay ? 'All day' : formatTimeLabel(event.startAt)}
                        </div>
                        <div className="mt-1 text-sm text-gray-500">
                            {event.ownerName || event.ownerCitizenId || 'Unassigned'}
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}

export default EventListPanel;
